module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Water-mixer-c8c019bbac6cbba324fcbdce43cf43ad.svg";